import styled from 'styled-components';

export const DarkGreyButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  a {
    color: var(--dark-grey-4) !important;

    &:hover {
      color: var(--dark-grey-4) !important;
    }
  }
`;

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--size-2h);
  width: 100%;
`;

export const RedBoldText = styled.strong`
  color: #d04145;
  font-weight: bold;
`;

export const FormatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

export const FormatBox = styled.div`
  background: #f9f9f9;
  padding: 1.5rem;
  border-radius: 0.75rem;
  border: 1px solid #ddd;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  font-size: 1rem;
  line-height: 1.6;

  h3 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
  }

  p {
    margin: 0.25rem 0;
  }
`;
